import React,{useEffect, useState} from "react";
import QRCode  from "qrcode";
import Main from "../../components/template/Main";
import {get,post,put} from '../../store/config/register';
import { parse,format } from "date-fns";
import { tooltip } from '@deepdub/react-ok-tooltip';
import './Visitante.css';
import { FiUpload } from 'react-icons/fi';
import { toast } from 'react-toastify';
import { useHistory } from "react-router-dom";
import QrCode from "../Qrcode/Qrcode";
import validator from 'validator';
import TelefoneBrasileiroInput from "react-telefone-brasileiro";
import Compressor from 'compressorjs';
import { empresa_Id,login_Id } from "../../store/config/dadosuser";

import  DatePicker  from "react-mobile-datepicker";


import avatar from '../../assets/imgs/avatar.png';

import 'react-nice-dates/build/style.css'

  
const initialState ={
  visitante: {
    id: 0,
    empresa_Id: empresa_Id,
    nome:'',
    sobrenome: '',
    dT_Nascimento: new Date(2000,0,1),
    data_Nascimento: null,
    email:'',
    celular: '',
    inicio: format(new Date(),'yyyy-MM-dd'),
    fim: format(new Date().setDate(new Date().getDate()),'yyyy-MM-dd'),
    foto: null,
    anfitriao_Id: 0,
    qrcode: null
  }
}
let type='';

const headerProps = {
  icon: "users",
  title: "Cadastro de Visitantes",
}

export default function VisitanteCadastro(props){
  const history = useHistory(); 
  const [visitante,setVisitante]=useState(initialState.visitante);
  const [usuario,setUsuario]= useState({});
  const [src,SetSrc]=useState('');
  const [avatarUrl, setAvatarUrl] = useState(null);
  const [imageAvatar, setImageAvatar] = useState(null);
  const [temImagem,setTemImagem]=useState(0);
  const id=props.match.params.id;
  const [showPostPesquisa, setShowPostPesquisa] = useState(false);

  const [isOpen,setIsOpen]= useState(false);


async function VerificaUsuario(){
 
  visitante.Empresa_Id = empresa_Id;
  visitante.anfitriao_Id =login_Id;

  if(login_Id > 0){
    const  result = await  get(`/Login/v1/${login_Id}`);
    if(result !== null){
      visitante.anfitriao = result.nome;
      visitante.unidade_id =result.unidade_Id;
      setUsuario(result);
    }
 }

}
  useEffect(() =>{
    
    VerificaUsuario();
    if ( id !== undefined){
      setVisitante({...visitante, id: id}) ;
      
      buscaVisitante(id);
  }

  },[])

    useEffect(()=>{
      let inicio =parse(visitante.inicio,'yyyy-MM-dd',new Date());
      setVisitante({...visitante, fim: format(inicio.setDate(inicio.getDate()),'yyyy-MM-dd')});
    },[visitante.inicio])


  function togglePostModal(item){
    setShowPostPesquisa(!showPostPesquisa) //trocando de true pra false
    if(!showPostPesquisa === false){
      history.push("/Visitantes")
    }

}



  async function buscaVisitante(id){
    const vis=await get(`/Visitante/v1/${id}`);

  if(vis != null){
          
      if (vis.foto !== null){
        const image = dataURLtoFile(`data:${type};base64,${vis.foto}`,'teste.png')
       
     setImageAvatar(image);
    setAvatarUrl(URL.createObjectURL(image));
        
    setTemImagem(1);
    setVisitante({...visitante,foto: vis.foto});
    
  }else {
        setAvatarUrl(null);
        setImageAvatar(avatar);
        setTemImagem(0);
      }

      setVisitante({...visitante,
        id: vis.id,
        empresa_Id: empresa_Id,
        nome: vis.nome,
        sobrenome: vis.sobrenome,
        dT_Nascimento: parse(vis.dT_Nascimento,"yyyy-MM-dd'T'HH:mm:ss",new Date()),
        data_Nascimento:parse(vis.dT_Nascimento,"yyyy-MM-dd'T'HH:mm:ss",new Date()),
        email: vis.email,
        celular: vis.celular,
        inicio: format(parse(vis.inicio,"yyyy-MM-dd'T'HH:mm:ss",new Date()),'yyyy-MM-dd'),
        fim: format(parse(vis.fim,"yyyy-MM-dd'T'HH:mm:ss",new Date()),'yyyy-MM-dd'),
        anfitriao_Id: vis.anfitriao_Id,
        foto: vis.foto
      }); 


  
}
}

   async function handleFile(e){
        if(e.target.files[0]){
          const image = e.target.files[0];

          
          type='';
          if(image.type === 'image/jpeg' || image.type === 'image/png'){

            new Compressor( image, {
              quality: 0.6, // 0.6 can also be used, but its not recommended to go below.
              success: async( compressedResult) => {
                // compressedResult has the compressed file.
                // Use the compressed file to upload the images to your server.        
                type=compressedResult.type;
                setImageAvatar(compressedResult);
                setAvatarUrl(URL.createObjectURL(compressedResult))
                let base64=await toBase64(compressedResult);          
                if (type ==='image/jpeg'){
                  setVisitante({...visitante,foto: base64.replace('data:image/jpeg;base64,','')});
                }else{
                  setVisitante({...visitante, foto: base64.replace('data:image/png;base64,','')});
                }
              },
            });
            

          }else{
            alert('Envie uma imagem do tipo PNG ou JPEG');
            setImageAvatar(null);
            setAvatarUrl(null);
            return null;
          }
    
        }
    
      }


    function  updateField(event){
      const vis ={...visitante}
        
      vis[event.target.name] =event.target.value
        setVisitante(vis);
}


function dataURLtoFile(dataurl, filename) {

  var arr = dataurl.split(','),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]), 
      n = bstr.length, 
      u8arr = new Uint8Array(n);
      
  while(n--){
      u8arr[n] = bstr.charCodeAt(n);
  }
  
  return new File([u8arr], filename, {type:mime});
}

async function Validar(){

let hoje = parse(format(new Date(),'yyyy-MM-dd'),'yyyy-MM-dd',new Date());

 

  if(visitante.nome === ''){
    toast.error("Digite o nome");
    return false;
  }
  if(visitante.sobrenome === ''){
    toast.error("Digite o sobrenome");
    return false;
  }
  if(visitante.data_Nascimento === null){
    toast.error("Selecione uma Data de Nascimento");
    return false;
  }

  if(visitante.email !== ''){
      if(validator.isEmail(visitante.email) === false) {
      toast.error('E-mail inválido.')
      return false;
  }else {
    if(visitante.id === 0){
   
      const data ={email: visitante.email};
      const e = await post('/Visitante/v1/Email',data)
      if(e !== ''){
       toast.error('E-mail já cadastrado!');
       return false;
      }
    }
     
  }
  }
if(visitante.foto === null){
  if(visitante.celular === ''){
    toast.error("Digite o celular");
    return false;
  }else if(visitante.celular.length <14){
    toast.error('Celular inválido!');
    return false;
  }
}

if(visitante.id === 0){
  if( parse(visitante.inicio,'yyyy-MM-dd',new Date()) < hoje){
    toast.error("Não é permitido que a data de visita, seja anterior à hoje");
    return false;
  }
}

   return true;
}

async function enviarEmail(){
  let emails =[];
   emails.push(visitante.email);

   let data =  { sender:emails, subject: 'QRCode Acesso',content: 'Segue em anexo o QrCode:', image: src.toString().replace('data:image/png;base64,','')}
   let result =await post('/Email/v1',data);
   await toast.success('email enviado com sucesso');
}

async function enviarWhatsapp(){
  let message="https://api.whatsapp.com/send?phone=55 "+visitante.celular+"&text=Boa tarde, tudo bem?";
  window.location.replace(message);
}
  
async function setFoto(){
  if(visitante.foto !== null) {
    setVisitante({...visitante,foto: visitante.foto})
    
    //visitante.Foto =visitante.Foto;
  }else {
    console.log(imageAvatar);
    if(imageAvatar !== null){
      if(imageAvatar !=="data:image/png;base64,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") {
        let base64=await toBase64(imageAvatar); 
      setVisitante({...visitante,foto: base64.replace('data:image/jpeg;base64,','').replace('data:image/png;base64,','').replace('data:application/octet-stream;base64,','')})
    
      let foto = base64.replace('data:image/jpeg;base64,','').replace('data:image/png;base64,','').replace('data:application/octet-stream;base64,','');
      visitante.foto=foto;
      toast.success(foto)
      }
    }
  }
}
  async function save (){
      if( await Validar()){
//toast.success("Validou");
       await setFoto();
       //toast.success("Foto");
      await  GerarQrcode();
      // toast.success("Qrcode");
        visitante.unidade_id =usuario.unidade_Id;
              if(visitante.id === 0){
                
                visitante.dT_Nascimento=format(visitante.data_Nascimento,'yyyy-MM-dd')
                let resp =  await post(`/Visitante/v1`,visitante);
                //toast.success(resp);
                    setVisitante({...visitante,id: resp.Id})
                      visitante.id =resp.id;
                     
                  }else{
                    await put(`/Visitante/v1/${visitante.id}`,visitante);
                  }
                 
                  await   toast.success("Visitante gravado com sucesso!");
                  togglePostModal(visitante);
      }
  }


  function clear(){  
    setVisitante(initialState.visitante);
    setAvatarUrl(null);
    setImageAvatar(null);
    history.push('/Visitantes')
  }

  async function GerarQrcode(){

    let num= Math.floor(Math.random() * (999999 - 100000 + 1) + 100000);
    
    const result= await get(`/Visitante/v1/Qrcode/${num}`);

     if(result.qrcode === false){
      QRCode.toDataURL(num.toString()).then(SetSrc);

        setVisitante({...visitante,qrcode: num.toString()});
        visitante.qrcode =num.toString();
        visitante.anfitriao = usuario.nome;
       }else {
        GerarQrcode();
       }  
  }

    const toBase64 = file => new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
  });

  const dateConfig = {
    'date': {
      format: 'DD',
      caption: 'Dia',
      step: 1,
  },
  'month': {
      format: 'MM',
      caption: 'Mês',
      step: 1,
  },
  'year': {
    format: 'YYYY',
    caption: 'Ano',
    step: 1,
}
  
};

function handleCancel() {
  setIsOpen(false);
}

function handleSelect (time) {
  setIsOpen(false);
  setVisitante({...visitante, dT_Nascimento:time,data_Nascimento:time})
}

    function render(){
        return (
            <div className="form">
               <label className="label-avatar">
              <span>
                <FiUpload color="#FFF" size={25} />
              </span>

              <input type="file" accept="image/*" onChange={handleFile}  /><br/>
              { avatarUrl === null ? 
                <img src={avatar} width="180" height="210" alt="Foto de perfil do usuario" />
                :
                <img src={avatarUrl} width="180" height="210" alt="Foto de perfil do usuario" />
              }
            </label>

            

            <div className="nome-visitante">
                <div className="form-group">
                  <label>Nome:</label>
                  <input type="text" name="nome" 
                  placeholder="Nome" 
                    className="form-control" value={visitante.nome} 
                    onChange={e => updateField(e)} />
                </div>
            </div> 
            <div className="nome-visitante">
                <div className="form-group">
                  <label>Sobrenome:</label>
                  <input type="text" name="sobrenome" 
                  placeholder="Sobrenome" 
                    className="form-control" value={visitante.sobrenome} 
                    onChange={e => updateField(e)} />
                </div>
            </div> 

            <div className="data0">
              <div className="form-group">
                    <label>Data Nascimento:</label>
                     <input  name="data_Nascimento"  className="form-control" readOnly onClick={()=> {setIsOpen(true);}}
                    value={visitante.data_Nascimento !== null ?format(visitante.data_Nascimento,'dd/MM/yyyy') : ''}/> 
                        <DatePicker min={new Date(1929,1,1)} confirmText="Selecionar" cancelText="Cancelar" headerFormat="DD/MM/YYYY"className="form-control"  showCaption={true} dateConfig={dateConfig} 
                        value={visitante.data_Nascimento === null ? new Date(2000,0,1) : visitante.data_Nascimento}
                        isOpen={isOpen}
                        onSelect={(time)=> handleSelect(time)}
                        onCancel={()=> handleCancel()}/>
              </div>
            </div>

            <div className="email">
              <div className="form-group">
                  <label>E-mail: (opcional)</label>
                  <input type="text" name="email"
                  placeholder="Email" 
                  className="form-control" value={visitante.email} 
                  onChange={e => updateField(e)} />
              </div>
            </div>


            <div className="telefone">
              <div className="form-group">
                  <label>Celular:</label>
                  <TelefoneBrasileiroInput
                  name="celular"
                  className="form-control"
                  temDDD={true}
                value={visitante.celular}
                placeholder="Celular" 
                onChange={e => updateField(e)}
            />
              </div>
            </div>


            <div className="section">
                <div className="data1">
                  <label className="control-label">{visitante.id > 0 ? (<b>*</b>):null}<strong>Data Visita:</strong></label>
                  <input type="date" name="inicio" {...tooltip('Campo não pode ser modificado na edição.')} readOnly={visitante.id !== 0 ? true : false} className="form-control" 
                    value={visitante.inicio}
                    onChange={e => updateField(e)} />
                </div><br/>

                {/* <div class="data2">
                  <label className="control-label"><b>*</b>Até dia:</label>
                  <input type="date" name="fim" readOnly className="form-control"
                    value={visitante.fim}
                    onChange={e => updateField(e)} />
                </div> */}
            </div>

              
            <hr/>
             {visitante.id > 0 && (<label>* O campo não pode ser alterado</label>) }
           
            <div id="botao">
                  <button  className="btn btn-primary ml-2" onClick={ async e =>  await save()}>
                    Salvar
                  </button>
                  <button className="btn btn-secondary ml-2" onClick={e => clear()}>
                    Cancelar
                  </button>
            </div>
              {showPostPesquisa && (
            <QrCode
            conteudo={{...visitante}}
            close={togglePostModal}
            />
            )}
            
        </div>
        );
    }

    return(
        <Main {...headerProps}>
            {render()}
        </Main>
   
    );
}